<pbc-filter [config]="FotoKategorienFilterConfig" [filter]="fotoKategorien.filter$ | async" (filterChange)="fotoKategorien.filter$.next($event)"></pbc-filter>
